import { Box, Flex } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import { Helmet } from "react-helmet"
import { Link } from "react-router-dom"

import {
  ButtonLink,
  Content,
  Container,
  LinkArrow,
  ReadmoreLink,
  SearchBox,
  SubTitle,
  DividerText,
  DividerTextBorder,
  TitleBorder,
} from "areas/helpdesk/index"
import Loading from "areas/helpdesk/loading"
import { getHreflangs } from "helpers/application"
import fetchArticleResults from "hoc/helpdesk/fetch-article-results"

const Article = ({ results }) => {
  const [articleSize, setArticleSize] = useState(6)

  useEffect(() => {
    setArticleSize(6)
  }, [results.article.number])

  if (!results.article.name) {
    return <Loading />
  }

  const relatedArticles = results.related_articles
  return (
    <Box textAlign="center">
      <Helmet>
        <title>{results.article.name}</title>
        <link
          href={`https://${sl.config.site_url}/helpdesk/a/${results.article?.number}/${results.article?.slug}`}
          rel="canonical"
        />
        {getHreflangs(
          `/helpdesk/a/${results.article?.number}/${results.article?.slug}`
        ).map(({ href, hreflang }) => (
          <link
            href={href}
            hrefLang={hreflang}
            key={hreflang}
            rel="alternate"
          />
        ))}
      </Helmet>
      <TitleBorder>{results.article.name}</TitleBorder>
      <SearchBox
        data-cy="helpdesk-article"
        my={{ _: 4, tablet: 9 }}
        p={{ _: 3, tablet: 8 }}
      >
        <Container
          dangerouslySetInnerHTML={{ __html: results.article.text }}
          mb={{ _: 5, tablet: 8 }}
        />
      </SearchBox>
      {relatedArticles.length > 0 && (
        <Box mb={{ _: 4, tablet: 5 }}>
          <Box m="64px 0 32px">
            <DividerTextBorder>
              <DividerText>Related Articles</DividerText>
            </DividerTextBorder>
          </Box>
          <Flex
            addYPadding
            flexDirection={{ _: "column", tablet: "row" }}
            flexWrap="wrap"
            gutter={2}
          >
            {relatedArticles.slice(0, articleSize).map((relArticle, index) => (
              <Box display="flex" flex="0 0 33%" key={`relArticle_${index}`}>
                <SearchBox
                  minHeight={{ _: "160px", tablet: "300px" }}
                  px={3}
                  py={5}
                >
                  <Box height="90%">
                    <SubTitle
                      as={Link}
                      data-lc="article"
                      to={`/helpdesk/a/${relArticle.number}/${relArticle.slug}`}
                    >
                      {relArticle.name}
                    </SubTitle>
                    <Content my={3}>
                      {relArticle.preview}
                      {relArticle.preview.length > 160 ? "..." : ""}
                    </Content>
                  </Box>
                  <ReadmoreLink
                    as={Link}
                    data-lc="article"
                    to={`/helpdesk/a/${relArticle.number}/${relArticle.slug}`}
                  >
                    <Flex>
                      <LinkArrow /> Keep Reading
                    </Flex>
                  </ReadmoreLink>
                </SearchBox>
              </Box>
            ))}
          </Flex>
        </Box>
      )}
      {Object.keys(relatedArticles).length > articleSize && (
        <ButtonLink onClick={() => setArticleSize(articleSize + 3)}>
          Show More
        </ButtonLink>
      )}
    </Box>
  )
}

Article.propTypes = {
  results: PropTypes.shape({
    article: PropTypes.object.isRequired,
    related_articles: PropTypes.array.isRequired,
  }).isRequired,
}

export default fetchArticleResults(Article)
